import { render, staticRenderFns } from "./blogGroup.vue?vue&type=template&id=ec635ce6&scoped=true"
import script from "./blogGroup.vue?vue&type=script&lang=js"
export * from "./blogGroup.vue?vue&type=script&lang=js"
import style0 from "./blogGroup.vue?vue&type=style&index=0&id=ec635ce6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec635ce6",
  null
  
)

export default component.exports